import bugsnag from '@bugsnag/browser';
import { DEBUG, BUGSNAG_API_KEY } from '../constants/env';

export interface NotifyErrParams {
  err?: Error | string | string[];
  logToConsole?: boolean;
}

const PRODUCTION = 'production';

export default bugsnag.createClient({
  apiKey: BUGSNAG_API_KEY,

  // Only notify in production
  releaseStage: DEBUG ? 'development' : PRODUCTION,
  enabledReleaseStages: [PRODUCTION],

  collectUserIp: false, // gdpr compliance

  // Errors which do not originate from our app should not be logged
  autoDetectErrors: false,
});
